import React from 'react';

const BabiDocLogo = ({ className = "w-10 h-10" }) => {
  return (
    <svg
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Cercle vert - adapté aux couleurs de la page */}
      <circle cx="50" cy="50" r="50" fill="#14B8A6" />
      
      {/* Carte de la Côte d'Ivoire en blanc - tracé plus épais */}
      <path
        d="M 50 25 
           C 47 28, 45 32, 44 36
           C 43 40, 42 44, 40 48
           C 38 52, 37 56, 35 60
           C 33 64, 32 68, 31 72
           L 31 76
           L 38 76
           C 42 76, 45 74, 47 71
           C 49 68, 50 65, 50 63
           C 50 65, 51 68, 53 71
           C 55 74, 58 76, 62 76
           L 69 76
           L 69 72
           C 68 68, 67 64, 65 60
           C 63 56, 62 52, 60 48
           C 58 44, 57 40, 56 36
           C 55 32, 53 28, 50 25
           Z"
        fill="white"
        stroke="white"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BabiDocLogo;
